/* tslint:disable */
/* eslint-disable */
/**
 * cellera-backend API spec
 * Backend Service for Cellera | [swagger.json](cellera/swagger.json)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  BiomarkerOcrRequestResponseDto,
  BiomarkerOcrRequestsListResponseDto,
  BiomarkerResponseDto,
  BiomarkersListResponseDto,
  CreateBiomarkerDto,
  ErrorResponse,
  ProcessBiomarkerFileDto,
  UpdateBiomarkerDto,
} from '../models/index';
import {
    BiomarkerOcrRequestResponseDtoFromJSON,
    BiomarkerOcrRequestResponseDtoToJSON,
    BiomarkerOcrRequestsListResponseDtoFromJSON,
    BiomarkerOcrRequestsListResponseDtoToJSON,
    BiomarkerResponseDtoFromJSON,
    BiomarkerResponseDtoToJSON,
    BiomarkersListResponseDtoFromJSON,
    BiomarkersListResponseDtoToJSON,
    CreateBiomarkerDtoFromJSON,
    CreateBiomarkerDtoToJSON,
    ErrorResponseFromJSON,
    ErrorResponseToJSON,
    ProcessBiomarkerFileDtoFromJSON,
    ProcessBiomarkerFileDtoToJSON,
    UpdateBiomarkerDtoFromJSON,
    UpdateBiomarkerDtoToJSON,
} from '../models/index';

export interface CreateBiomarkerRequest {
    createBiomarkerDto: CreateBiomarkerDto;
}

export interface DeleteBiomarkerRequest {
    biomarkerId: string;
}

export interface GetBiomarkersRequest {
    page?: number;
    limit?: number;
    search?: string;
    dateFrom?: Date;
    dateTo?: Date;
    status?: GetBiomarkersStatusEnum;
    sortBy?: GetBiomarkersSortByEnum;
    sortOrder?: GetBiomarkersSortOrderEnum;
}

export interface GetBiomarkersByPatientIdRequest {
    patientId: string;
    page?: number;
    limit?: number;
    search?: string;
    dateFrom?: Date;
    dateTo?: Date;
    status?: GetBiomarkersByPatientIdStatusEnum;
    sortBy?: GetBiomarkersByPatientIdSortByEnum;
    sortOrder?: GetBiomarkersByPatientIdSortOrderEnum;
}

export interface GetOcrRequestsRequest {
    pageSize: number;
    page?: number;
    nextPageToken?: string;
}

export interface GetOcrStatusRequest {
    requestId: string;
}

export interface ProcessBiomarkerFileRequest {
    processBiomarkerFileDto: ProcessBiomarkerFileDto;
}

export interface UpdateBiomarkerRequest {
    biomarkerId: string;
    updateBiomarkerDto: UpdateBiomarkerDto;
}

/**
 * 
 */
export class PatientBiomarkersApi extends runtime.BaseAPI {

    /**
     * Create a new biomarker record
     */
    async createBiomarkerRaw(requestParameters: CreateBiomarkerRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<BiomarkerResponseDto>> {
        if (requestParameters['createBiomarkerDto'] == null) {
            throw new runtime.RequiredError(
                'createBiomarkerDto',
                'Required parameter "createBiomarkerDto" was null or undefined when calling createBiomarker().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/patient/biomarkers`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CreateBiomarkerDtoToJSON(requestParameters['createBiomarkerDto']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => BiomarkerResponseDtoFromJSON(jsonValue));
    }

    /**
     * Create a new biomarker record
     */
    async createBiomarker(requestParameters: CreateBiomarkerRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<BiomarkerResponseDto> {
        const response = await this.createBiomarkerRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Delete a biomarker record
     */
    async deleteBiomarkerRaw(requestParameters: DeleteBiomarkerRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['biomarkerId'] == null) {
            throw new runtime.RequiredError(
                'biomarkerId',
                'Required parameter "biomarkerId" was null or undefined when calling deleteBiomarker().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/patient/biomarkers/{biomarkerId}`.replace(`{${"biomarkerId"}}`, encodeURIComponent(String(requestParameters['biomarkerId']))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Delete a biomarker record
     */
    async deleteBiomarker(requestParameters: DeleteBiomarkerRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.deleteBiomarkerRaw(requestParameters, initOverrides);
    }

    /**
     * Supports search by name, date range filtering, status filtering (All/In range/Out of range), and sorting by date/name
     * Get patient\'s biomarkers with filtering, sorting, and pagination
     */
    async getBiomarkersRaw(requestParameters: GetBiomarkersRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<BiomarkersListResponseDto>> {
        const queryParameters: any = {};

        if (requestParameters['page'] != null) {
            queryParameters['page'] = requestParameters['page'];
        }

        if (requestParameters['limit'] != null) {
            queryParameters['limit'] = requestParameters['limit'];
        }

        if (requestParameters['search'] != null) {
            queryParameters['search'] = requestParameters['search'];
        }

        if (requestParameters['dateFrom'] != null) {
            queryParameters['dateFrom'] = (requestParameters['dateFrom'] as any).toISOString();
        }

        if (requestParameters['dateTo'] != null) {
            queryParameters['dateTo'] = (requestParameters['dateTo'] as any).toISOString();
        }

        if (requestParameters['status'] != null) {
            queryParameters['status'] = requestParameters['status'];
        }

        if (requestParameters['sortBy'] != null) {
            queryParameters['sortBy'] = requestParameters['sortBy'];
        }

        if (requestParameters['sortOrder'] != null) {
            queryParameters['sortOrder'] = requestParameters['sortOrder'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/patient/biomarkers`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => BiomarkersListResponseDtoFromJSON(jsonValue));
    }

    /**
     * Supports search by name, date range filtering, status filtering (All/In range/Out of range), and sorting by date/name
     * Get patient\'s biomarkers with filtering, sorting, and pagination
     */
    async getBiomarkers(requestParameters: GetBiomarkersRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<BiomarkersListResponseDto> {
        const response = await this.getBiomarkersRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Supports search by name, date range filtering, status filtering (All/In range/Out of range), and sorting by date/name
     * Get patient\'s biomarkers by patient ID with filtering, sorting, and pagination
     */
    async getBiomarkersByPatientIdRaw(requestParameters: GetBiomarkersByPatientIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<BiomarkersListResponseDto>> {
        if (requestParameters['patientId'] == null) {
            throw new runtime.RequiredError(
                'patientId',
                'Required parameter "patientId" was null or undefined when calling getBiomarkersByPatientId().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['page'] != null) {
            queryParameters['page'] = requestParameters['page'];
        }

        if (requestParameters['limit'] != null) {
            queryParameters['limit'] = requestParameters['limit'];
        }

        if (requestParameters['search'] != null) {
            queryParameters['search'] = requestParameters['search'];
        }

        if (requestParameters['dateFrom'] != null) {
            queryParameters['dateFrom'] = (requestParameters['dateFrom'] as any).toISOString();
        }

        if (requestParameters['dateTo'] != null) {
            queryParameters['dateTo'] = (requestParameters['dateTo'] as any).toISOString();
        }

        if (requestParameters['status'] != null) {
            queryParameters['status'] = requestParameters['status'];
        }

        if (requestParameters['sortBy'] != null) {
            queryParameters['sortBy'] = requestParameters['sortBy'];
        }

        if (requestParameters['sortOrder'] != null) {
            queryParameters['sortOrder'] = requestParameters['sortOrder'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/patient/biomarkers/{patientId}`.replace(`{${"patientId"}}`, encodeURIComponent(String(requestParameters['patientId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => BiomarkersListResponseDtoFromJSON(jsonValue));
    }

    /**
     * Supports search by name, date range filtering, status filtering (All/In range/Out of range), and sorting by date/name
     * Get patient\'s biomarkers by patient ID with filtering, sorting, and pagination
     */
    async getBiomarkersByPatientId(requestParameters: GetBiomarkersByPatientIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<BiomarkersListResponseDto> {
        const response = await this.getBiomarkersByPatientIdRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Retrieve all OCR processing requests for the authenticated patient with pagination
     * Get patient\'s OCR processing requests
     */
    async getOcrRequestsRaw(requestParameters: GetOcrRequestsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<BiomarkerOcrRequestsListResponseDto>> {
        if (requestParameters['pageSize'] == null) {
            throw new runtime.RequiredError(
                'pageSize',
                'Required parameter "pageSize" was null or undefined when calling getOcrRequests().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['page'] != null) {
            queryParameters['page'] = requestParameters['page'];
        }

        if (requestParameters['pageSize'] != null) {
            queryParameters['pageSize'] = requestParameters['pageSize'];
        }

        if (requestParameters['nextPageToken'] != null) {
            queryParameters['nextPageToken'] = requestParameters['nextPageToken'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/patient/biomarkers/ocr-requests/list`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => BiomarkerOcrRequestsListResponseDtoFromJSON(jsonValue));
    }

    /**
     * Retrieve all OCR processing requests for the authenticated patient with pagination
     * Get patient\'s OCR processing requests
     */
    async getOcrRequests(requestParameters: GetOcrRequestsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<BiomarkerOcrRequestsListResponseDto> {
        const response = await this.getOcrRequestsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Check the current status of a biomarker OCR processing request
     * Get OCR processing status by request ID
     */
    async getOcrStatusRaw(requestParameters: GetOcrStatusRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<BiomarkerOcrRequestResponseDto>> {
        if (requestParameters['requestId'] == null) {
            throw new runtime.RequiredError(
                'requestId',
                'Required parameter "requestId" was null or undefined when calling getOcrStatus().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/patient/biomarkers/ocr-status/{requestId}`.replace(`{${"requestId"}}`, encodeURIComponent(String(requestParameters['requestId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => BiomarkerOcrRequestResponseDtoFromJSON(jsonValue));
    }

    /**
     * Check the current status of a biomarker OCR processing request
     * Get OCR processing status by request ID
     */
    async getOcrStatus(requestParameters: GetOcrStatusRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<BiomarkerOcrRequestResponseDto> {
        const response = await this.getOcrStatusRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Initiate asynchronous processing of a biomarker file (PDF, image) using VertexAI OCR. Returns immediately with a request ID to track progress.
     * Start biomarker file OCR processing
     */
    async processBiomarkerFileRaw(requestParameters: ProcessBiomarkerFileRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['processBiomarkerFileDto'] == null) {
            throw new runtime.RequiredError(
                'processBiomarkerFileDto',
                'Required parameter "processBiomarkerFileDto" was null or undefined when calling processBiomarkerFile().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/patient/biomarkers/process-file`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: ProcessBiomarkerFileDtoToJSON(requestParameters['processBiomarkerFileDto']),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Initiate asynchronous processing of a biomarker file (PDF, image) using VertexAI OCR. Returns immediately with a request ID to track progress.
     * Start biomarker file OCR processing
     */
    async processBiomarkerFile(requestParameters: ProcessBiomarkerFileRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.processBiomarkerFileRaw(requestParameters, initOverrides);
    }

    /**
     * Update a biomarker record
     */
    async updateBiomarkerRaw(requestParameters: UpdateBiomarkerRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<BiomarkerResponseDto>> {
        if (requestParameters['biomarkerId'] == null) {
            throw new runtime.RequiredError(
                'biomarkerId',
                'Required parameter "biomarkerId" was null or undefined when calling updateBiomarker().'
            );
        }

        if (requestParameters['updateBiomarkerDto'] == null) {
            throw new runtime.RequiredError(
                'updateBiomarkerDto',
                'Required parameter "updateBiomarkerDto" was null or undefined when calling updateBiomarker().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/patient/biomarkers/{biomarkerId}`.replace(`{${"biomarkerId"}}`, encodeURIComponent(String(requestParameters['biomarkerId']))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: UpdateBiomarkerDtoToJSON(requestParameters['updateBiomarkerDto']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => BiomarkerResponseDtoFromJSON(jsonValue));
    }

    /**
     * Update a biomarker record
     */
    async updateBiomarker(requestParameters: UpdateBiomarkerRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<BiomarkerResponseDto> {
        const response = await this.updateBiomarkerRaw(requestParameters, initOverrides);
        return await response.value();
    }

}

/**
 * @export
 */
export const GetBiomarkersStatusEnum = {
    All: 'all',
    InRange: 'in_range',
    OutOfRange: 'out_of_range'
} as const;
export type GetBiomarkersStatusEnum = typeof GetBiomarkersStatusEnum[keyof typeof GetBiomarkersStatusEnum];
/**
 * @export
 */
export const GetBiomarkersSortByEnum = {
    Date: 'date',
    Name: 'name',
    CreatedAt: 'createdAt'
} as const;
export type GetBiomarkersSortByEnum = typeof GetBiomarkersSortByEnum[keyof typeof GetBiomarkersSortByEnum];
/**
 * @export
 */
export const GetBiomarkersSortOrderEnum = {
    Asc: 'ASC',
    Desc: 'DESC'
} as const;
export type GetBiomarkersSortOrderEnum = typeof GetBiomarkersSortOrderEnum[keyof typeof GetBiomarkersSortOrderEnum];
/**
 * @export
 */
export const GetBiomarkersByPatientIdStatusEnum = {
    All: 'all',
    InRange: 'in_range',
    OutOfRange: 'out_of_range'
} as const;
export type GetBiomarkersByPatientIdStatusEnum = typeof GetBiomarkersByPatientIdStatusEnum[keyof typeof GetBiomarkersByPatientIdStatusEnum];
/**
 * @export
 */
export const GetBiomarkersByPatientIdSortByEnum = {
    Date: 'date',
    Name: 'name',
    CreatedAt: 'createdAt'
} as const;
export type GetBiomarkersByPatientIdSortByEnum = typeof GetBiomarkersByPatientIdSortByEnum[keyof typeof GetBiomarkersByPatientIdSortByEnum];
/**
 * @export
 */
export const GetBiomarkersByPatientIdSortOrderEnum = {
    Asc: 'ASC',
    Desc: 'DESC'
} as const;
export type GetBiomarkersByPatientIdSortOrderEnum = typeof GetBiomarkersByPatientIdSortOrderEnum[keyof typeof GetBiomarkersByPatientIdSortOrderEnum];
